export default __webpack_public_path__ + "static/media/012-tian tan buddha.f8348658.svg";